import React from "react";
import styled from "styled-components";
import PageMenu from "./PageMenu";
import useDesktop from "../Responsive/useDesktop";

const Wrapper = styled.div<{
    padding?: string;
    dekstop: boolean;
    row?: boolean;
}>`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  display: ${({ row }) => (row ? "flex" : "initial")};
  padding: ${({ padding }) => padding};
`;

function PageWrapper({ children, height, menu, padding, row }: IPageWrapper) {
    const dekstop = useDesktop();

    return (
        <div
            style={{
                display: dekstop ? "flex" : "block",
                height: height || "calc(100%)",
                backgroundColor: "#F9F9F9",
            }}
        >
            <Wrapper row={row} dekstop={dekstop} padding={padding}>
                {children}
            </Wrapper>
            {dekstop && menu && <PageMenu>{menu}</PageMenu>}
        </div>
    );
}

export interface IPageWrapper {
    children: any;
    padding?: string;
    row?: boolean;
    height?: string;
    menu?: any;
}

export default PageWrapper;
